<template>
    <v-data-iterator
      :items="['expense', 'income']"
      class="balance"
      content-tag="div"
      :content-class="'layout row wrap'"
      hide-actions
    >
      <template slot="header">
        <v-toolbar class="mb" color="primary" dark  flat>
          <v-toolbar-title>BALANCE SHEET</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- <v-btn lg flat class="primary white--text">PRINT</v-btn> -->
        </v-toolbar>
        <v-toolbar class="mb" color="white white--text" flat>
          <v-layout row>
            <v-flex>
              <v-autocomplete
                :items="firmsByBrand"
                :search-input.sync="searchInput"
                v-model="selectedFirm"
                class="mx-3"
                flat
                hide-no-data
                hide-details
                label="Select Firm"
                clearable
              ></v-autocomplete>
            </v-flex>

            <v-spacer/>

            <v-flex>
              <v-menu
                v-model="fromdatepicker"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  clearable
                  slot="activator"
                  v-model="filterInvoiceFrom"
                  single-line
                  label="From Date"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="filterInvoiceFrom" @input="fromdatepicker = false" />
              </v-menu>
            </v-flex>
            <v-flex>
              <v-menu
                v-model="todatepicker"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  clearable
                  slot="activator"
                  v-model="filterInvoiceTo"
                  label="To Date"
                  single-line
                  readonly
                ></v-text-field>
                <v-date-picker v-model="filterInvoiceTo" @input="todatepicker = false" />
              </v-menu>
            </v-flex>
              <v-flex>
                   <v-switch
                    style="margin-top: 13px;"
                    v-model="isDepriciation"
                    :label="`Calculate Depriciation: ${isDepriciation ? 'Yes' : 'No'}`"
                  ></v-switch>
              </v-flex>
          </v-layout>
        </v-toolbar>
      </template>
      

      <template slot="item" slot-scope="props">
        <v-flex xs12 sm6 md v-if="props.item === 'expense'">
          <v-card>
            <v-card-title class="primary white--text">Liabilities <v-spacer/> Amount</v-card-title>
            <v-divider />

            <v-list dense>
              <expand-card 
                v-if="selectedFirm"
                :value="propCapitalAC || 0 | amount"
                >
                <h3 slot="header">Prop capital A/C : </h3>
              </expand-card>

        <expand-card
            :hasItems="true"
            :value="securedLoansBankListTotal + totalLoan | amount"
          >  
            <template slot="header"> 
              <h3>Loans:</h3>
            </template>
            
            <template slot="items">
              <template :value="totalLoan || 0 | amount"
                :hasItems="sellerList.length > 0" >
              <v-expansion-panel-content 
              >
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-light">Unsecured Loans</b>
                    <v-spacer />
                    <h3>{{totalLoan || 0 | amount}}</h3>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <template v-for="creditor in sellerList.concat(buyerList)">
                <v-list-tile v-if="!!creditor.totalLoanGiven" :key="creditor['.key']" >
                  <v-list-tile-content>
                    <h3 class="primary--text font-weight-light">
                        <router-link target="_blank" :to="{
                          path: `/customers/${creditor['.key']}`
                        }">
                          {{creditor['name']}}
                        </router-link> :
                      </h3>
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">{{creditor.totalLoanGiven}}</v-list-tile-content>
                </v-list-tile>
                </template>
              </v-list>
            </v-expansion-panel-content>
            </template>
              <template :value="securedLoansBankListTotal || 0 | amount"
                :hasItems="securedLoansBankList.length > 0" >
              <v-expansion-panel-content 
              >
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-light">Secured Loans (Bank Account) :</b>
                    <v-spacer />
                    <h3>{{securedLoansBankListTotal || 0 | amount}}</h3>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <template v-for="bank in securedLoansBankList" >
                <v-list-tile v-bind:key="bank['.key']" >
                  <v-list-tile-content>
                   {{bank.bankName}}
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">{{bank.amount}}</v-list-tile-content>
                </v-list-tile>
                </template>
              </v-list>
            </v-expansion-panel-content>
            </template>
            </template>  
          </expand-card>

        <expand-card
            :hasItems="true"
            :value="(Number.parseFloat(liabilityTotal) + Number.parseFloat(totalSundryCreditors) + Number.parseFloat(expenseTotal) + Number.parseFloat(ITCData.liabilities.IGST) + Number.parseFloat(ITCData.liabilities.SGST) + Number.parseFloat(ITCData.liabilities.CGST)).toFixed(2)"
          >  
            <template slot="header"> 
              <h3>Current Liabilities:</h3>
            </template>
            
            <template slot="items">
              <template :value="liabilityTotal || 0 | amount"
                :hasItems="liabilitiesWPro.length > 0" >
              <v-expansion-panel-content 
              >
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-light">Current Liabilities:</b>
                    <v-spacer />
                    <h3>{{liabilityTotal || 0 | amount}}</h3>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <template v-for="liability in liabilitiesWPro">
                <v-list-tile v-if="liability.paymentTypeStatus === 'yet to confirm' && (liability.totalAmount || liability.openingBalance )> 0" v-bind:key="liability['.key']" >
                  <v-list-tile-content>
                   {{liability.liability}}
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">{{Number.parseFloat(liability.totalAmount + liability.openingBalance)}}</v-list-tile-content>
                </v-list-tile>
                </template>
              </v-list>
            </v-expansion-panel-content>
            </template>
              <template :value="totalSundryCreditors || 0 | amount"
                :hasItems="sellerList.length > 0" >
              <v-expansion-panel-content 
              >
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-light">Sundry Creditors:</b>
                    <v-spacer />
                    <h3>{{totalSundryCreditors || 0 | amount}}</h3>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <template v-for="creditor in sellerList" >
                <v-list-tile v-if="!!creditor.totalRemainingAmount" v-bind:key="creditor['.key']" >
                  <v-list-tile-content>
                     <h3 class="primary--text font-weight-light">
                        <router-link target="_blank" :to="{
                          path: `/customers/${creditor['.key']}`
                        }">
                          {{creditor['name']}}
                        </router-link> :
                      </h3>
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">{{creditor.totalRemainingAmount}}</v-list-tile-content>
                </v-list-tile>
                </template>
              </v-list>
            </v-expansion-panel-content>
            </template>

             <template :value="expenseTotal || 0 | amount"
                :hasItems="expensesWPro.length > 0" >
              <v-expansion-panel-content 
              >
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-light">Provisions:</b>
                    <v-spacer />
                    <h3>{{expenseTotal || 0 | amount}}</h3>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <template v-for="expense in expensesWPro" >
                <v-list-tile v-if="expense.paymentTypeStatus === 'yet to confirm' && expense.totalAmount > 0" v-bind:key="expense['.key']" >
                  <v-list-tile-content>
                    <h3 class="primary--text font-weight-light">{{expense.expense}}</h3>
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">{{expense.totalAmount}}</v-list-tile-content>
                </v-list-tile>
                </template>
              </v-list>
            </v-expansion-panel-content>
            </template>
                <template :value="(Number.parseFloat(ITCData.liabilities.IGST) + Number.parseFloat(ITCData.liabilities.SGST) + Number.parseFloat(ITCData.liabilities.CGST)).toFixed(2) || 0 | amount"
                :hasItems="true" >
              <v-expansion-panel-content 
              >
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-light"> GST Liabilities:</b>
                    <v-spacer />
                    <h3>{{(Number.parseFloat(ITCData.liabilities.IGST) + Number.parseFloat(ITCData.liabilities.SGST) + Number.parseFloat(ITCData.liabilities.CGST)).toFixed(2) || 0 | amount}}</h3>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <v-list-tile>
                  <v-list-tile-content>
                      <h3 class="primary--text font-weight-light">{{'IGST'}}</h3>
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ITCData.liabilities.IGST}}</v-list-tile-content>
                </v-list-tile>
                 <v-list-tile>
                  <v-list-tile-content>
                      <h3 class="primary--text font-weight-light">{{'CGST'}}</h3>
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ITCData.liabilities.CGST}}</v-list-tile-content>
                </v-list-tile>
                 <v-list-tile>
                  <v-list-tile-content>
                      <h3 class="primary--text font-weight-light">{{'SGST'}}</h3>
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ITCData.liabilities.SGST}}</v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-expansion-panel-content>
            </template>
            </template>  
          </expand-card>      

              <!-- End of Left Side Content --> 
            </v-list>
          </v-card>

          <!-- Liabilities i.e Left side Total -->
          <v-card>
            <v-card-title class="primary white--text">
              Total 
              <v-spacer />
              <h2>{{ ((propCapitalAC + totalSundryCreditors + totalLoan + securedLoansBankListTotal) + Number.parseFloat(expenseTotal) + Number.parseFloat(ITCData.liabilities.IGST) + Number.parseFloat(ITCData.liabilities.SGST) + Number.parseFloat(ITCData.liabilities.CGST)) || 0 | amount }}</h2>
            </v-card-title>
            <v-divider />
          </v-card>
        </v-flex>

        <!-- second side -->
        <v-flex xs12 sm6 md v-if="props.item === 'income'">
          <v-card>
            <v-card-title class="primary white--text">Assets <v-spacer/> Amount</v-card-title>
            <v-divider />
          </v-card>
        <v-list dense>
      

          <expand-card 
                :value="totalLoanAndAdvances || 0 | amount"
                :hasItems="buyerList.length > 0"
                >
                <template slot="header">
                  <h3>Loans & Advances :</h3>
                </template>
                <template slot="items">
                  <template v-for="creditor in buyerList.concat(sellerList)">
                  <expand-card v-if="!!creditor.totalLoanTaken" :key="creditor['.key']"
                    :header="creditor.name"
                    :value="creditor.totalLoanTaken"
                    containerClass="no-shadow"
                  >
                    <template slot="header">
                      <h3 class="primary--text font-weight-light">
                        <router-link target="_blank" :to="{
                          path: `/customers/${creditor['.key']}`
                        }">
                          {{creditor['name']}}
                        </router-link> :
                      </h3>
                    </template>
                  </expand-card>
                </template>
              </template>  
          </expand-card>

      

          <!-- Fixed Assets -->  
          <expand-card
            :hasItems="getAssetAccount.length > 0"
            :value="totalAssetAmount || 0 | amount"
          >  
            <template slot="header"> 
              <h3>Fixed Asset:</h3>
            </template>
            
            <template slot="items">
              <template v-for="(asset, e) in getAssetAccount" >
              <v-expansion-panel-content 
                v-if="asset.details.type != 'investments'"
                v-bind:key="e"
              >
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-light">{{ asset.details.asset }}</b> / {{ asset.details.category }} {{ asset.details.type }}
                    <v-spacer />
                    <h3>{{ ((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) -  Number.parseFloat(((asset.details.totalAmount + asset.details.openingBalance)  * (isDepriciation ? asset.details.depriciation : 0)) / 100) || 0 | amount ) || ((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) || 0 | amount )  }}</h3>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <v-list-tile v-for="(section, i) in asset.invoices" :key="i">
                  <v-list-tile-content>{{ new Date(section.date).toLocaleDateString('en-IN')  }}</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ section.totalAmount || section.openingBalance || '-'}}</v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-expansion-panel-content>
            </template>
            </template>  
          </expand-card>

          <!-- Investment Assets -->
          <expand-card
            :hasItems="getInvestmentAccount.length > 0"
            :value="totalInvestmentAmount || 0 | amount"
          >  
            <template slot="header"> 
              <h3>Investments:</h3>
            </template>
            
            <template slot="items">
              <template v-for="(asset, e) in getInvestmentAccount" >
              <v-expansion-panel-content 
                v-if="asset.details.type === 'investments'"
                v-bind:key="e"
              >
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-light">{{ asset.details.asset }}</b> / {{ asset.details.category }} {{ asset.details.type }}
                    <v-spacer />
                    <h3>{{ Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance) || 0 | amount }}</h3>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <v-list-tile v-for="(section, i) in asset.invoices" :key="i">
                  <v-list-tile-content>{{ new Date(section.date).toLocaleDateString('en-IN')  }}</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ section.totalAmount || section.openingBalance || '-'}}</v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-expansion-panel-content>
            </template>
            </template>  
          </expand-card>
      

          <expand-card
            :hasItems="true"
            :value="(Number.parseFloat(totalSundryDebitors)+ Number.parseFloat(savingsCurrentBankListTotal)+ Number.parseFloat(cashInHand)+Number.parseFloat(ITCData.assets.IGST) + Number.parseFloat(ITCData.assets.SGST) + Number.parseFloat(ITCData.assets.CGST)).toFixed(2) || 0 | amount"
          >  
            <template slot="header"> 
              <h3>Current Assets:</h3>
            </template>
            
            <template slot="items">
              <template :value="totalSundryDebitors || 0 | amount"
                :hasItems="buyerList.length > 0" >
              <v-expansion-panel-content 
              >
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-light">Sundry Debtors:</b>
                    <v-spacer />
                    <h3>{{totalSundryDebitors || 0 | amount}}</h3>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <template v-for="creditor in buyerList">
                <v-list-tile v-if="!!creditor.totalRemainingAmount" :key="creditor['.key']" >
                  <v-list-tile-content>
                   <h3 class="primary--text font-weight-light">
                        <router-link target="_blank" :to="{
                          path: `/customers/${creditor['.key']}`
                        }">
                          {{creditor['name']}}
                        </router-link> :
                      </h3>
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">{{creditor.totalRemainingAmount}}</v-list-tile-content>
                </v-list-tile>
                </template>
              </v-list>
            </v-expansion-panel-content>
            </template>

              <template :value="savingsCurrentBankListTotal || 0 | amount"
                :hasItems="savingsCurrentBankList.length > 0" >
              <v-expansion-panel-content 
              >
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-light">Bank Account :</b>
                    <v-spacer />
                    <h3>{{savingsCurrentBankListTotal || 0 | amount}}</h3>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <template v-for="bank in savingsCurrentBankList" >
                <v-list-tile  v-bind:key="bank['.key']">
                  <v-list-tile-content>
                   <template slot="header"><h3 class="primary--text font-weight-light">{{bank.bankName}}</h3></template>
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">{{bank.amount}}</v-list-tile-content>
                </v-list-tile>
                </template>
              </v-list>
            </v-expansion-panel-content>
            </template>
            <template :value="cashInHand || 0 | amount"
                :hasItems="false" >
              <v-expansion-panel-content 
              >
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-light">Cash in Hand :</b>
                    <v-spacer />
                    <h3>{{cashInHand || 0 | amount}}</h3>
                  </v-card-title>
                </v-card>
              </div>
            </v-expansion-panel-content>
            </template>
               <template :value="(Number.parseFloat(ITCData.assets.IGST) + Number.parseFloat(ITCData.assets.SGST) + Number.parseFloat(ITCData.assets.CGST)).toFixed(2) || 0 | amount"
                :hasItems="true" >
              <v-expansion-panel-content 
              >
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-light"> GST Assets:</b>
                    <v-spacer />
                    <h3>{{(Number.parseFloat(ITCData.assets.IGST) + Number.parseFloat(ITCData.assets.SGST) + Number.parseFloat(ITCData.assets.CGST)).toFixed(2) || 0 | amount}}</h3>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <v-list-tile>
                  <v-list-tile-content>
                      <h3 class="primary--text font-weight-light">{{'IGST'}}</h3>
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ITCData.assets.IGST}}</v-list-tile-content>
                </v-list-tile>
                 <v-list-tile>
                  <v-list-tile-content>
                      <h3 class="primary--text font-weight-light">{{'CGST'}}</h3>
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ITCData.assets.CGST}}</v-list-tile-content>
                </v-list-tile>
                 <v-list-tile>
                  <v-list-tile-content>
                      <h3 class="primary--text font-weight-light">{{'SGST'}}</h3>
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ITCData.assets.SGST}}</v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-expansion-panel-content>
            </template>
          
            </template>  
          </expand-card>

          <!-- Total Right side -->
          <v-card>
            <v-spacer/>
            <v-card-title class="primary white--text">Total<v-spacer /><h2>{{ Number.parseFloat(cashInHand  + savingsCurrentBankListTotal + totalSundryDebitors  + totalLoanAndAdvances + totalInvestmentAmount + totalAssetAmount + Number.parseFloat(ITCData.assets.IGST) + Number.parseFloat(ITCData.assets.SGST) + Number.parseFloat(ITCData.assets.CGST) ) || 0 | amount }}</h2></v-card-title>
          </v-card>
        </v-list> 
       </v-flex>
      </template>
    </v-data-iterator>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']

import ExpandCard from './expandCard';

  export default {
    components: {
      ExpandCard,
    },
    watch: {
    selectedFirm(nval, oval) {
        if (oval !== nval) {
        this.getData();
        }
      },
    },
    created() {
      this.$bindAsArray('invoices', this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear))
      this.$bindAsArray('expenses', this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray('liabilities', this.$root.$firebaseRefs.liabilities.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray('assets', this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray('accounts', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray('buyers', this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray('sellers', this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray("customerDeposit", this.$root.$firebaseRefs.customerDeposit.orderByChild('brand').equalTo(this.selectedBrand))
      this.getData();
    },
    computed: {
      ...mapGlobalGetters(['selectedBrand','brandFinYear']),
      selectedFirmDetail() {
        if(!this.selectedFirm) { return null }
        return this.firms.find(item => item['.key'] === this.selectedFirm)
      },
      ITCData(){
        let inputGST = {
        IGST: 0,
        CGST: 0,
        SGST: 0
      };
      let outputGST = {
        IGST: 0,
        CGST: 0,
        SGST: 0
      };
        let toDate = this.filterInvoiceTo ?  new Date(this.filterInvoiceTo).getTime() : null;
        let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
        let filteredInvoices = this.invoices.filter(item => item["brand"] === this.selectedBrand
        && item['items']
        && item['items'].length
        && (this.selectedFirm ? item["firm"] == this.selectedFirm : true)
        && (this.selectedfromDate ? item.date >= fromDate : true) &&
          (this.selectedtoDate ? item.date <= toDate : true));
        filteredInvoices.map(invoice => {
            if (invoice.isBuyer) {
            invoice.items.map(item => {
              outputGST.SGST += (item.SGST_val && !item.SGST_ITC_paid)
                ? Number.parseFloat(item.SGST_val)
                : 0;
              outputGST.CGST += (item.CGST_val && !item.CGST_ITC_paid)
                ? Number.parseFloat(item.CGST_val)
                : 0;
              outputGST.IGST += (item.IGST_val && !item.IGST_ITC_paid)
                ? Number.parseFloat(item.IGST_val)
                : 0;
            });
          } else {
            invoice.items.map(item => {
              inputGST.SGST += (item.SGST_val && !item.SGST_ITC_paid)
                ? Number.parseFloat(item.SGST_val)
                : 0;
              inputGST.CGST += (item.CGST_val && !item.CGST_ITC_paid)
                ? Number.parseFloat(item.CGST_val)
                : 0;
              inputGST.IGST += (item.IGST_val && !item.IGST_ITC_paid)
                ? Number.parseFloat(item.IGST_val)
                : 0;
            });
          }
        });

        let returnOBJ = {
          liabilities : {
            SGST : 0,
            CGST : 0,
            IGST : 0
          },
          assets : {
            SGST : 0,
            CGST : 0,
            IGST : 0
          }
        }

        //IGST
        if(Number.parseFloat(outputGST.IGST) < Number.parseFloat(inputGST.IGST)) {
          returnOBJ.assets.IGST = (Number.parseFloat(inputGST.IGST) - (Number.parseFloat(outputGST.IGST) + Number.parseFloat(outputGST.CGST) + Number.parseFloat(outputGST.SGST))).toFixed(2)
        } else {
          returnOBJ.assets.IGST = 0;
        } 

        if((Number.parseFloat(outputGST.IGST) > Number.parseFloat(inputGST.IGST))) {
          returnOBJ.liabilities.IGST = (Number.parseFloat(outputGST.IGST) - (Number.parseFloat(inputGST.IGST))).toFixed(2)
        } else {
          returnOBJ.liabilities.IGST = 0;
        } 

        //CGST
        if(Number.parseFloat(inputGST.CGST) > (Number.parseFloat(outputGST.CGST))) {
          returnOBJ.assets.CGST = (Number.parseFloat(inputGST.CGST) - (Number.parseFloat(outputGST.CGST))).toFixed(2)
        } else {
          returnOBJ.assets.CGST = 0;
        } 

        if(Number.parseFloat(inputGST.CGST) < (Number.parseFloat(outputGST.CGST))) {
          returnOBJ.liabilities.CGST = (Number.parseFloat(outputGST.CGST) - Number.parseFloat(inputGST.CGST)).toFixed(2)
        } else {
          returnOBJ.liabilities.CGST = 0;
        }
        
        
        //SGST
        if(Number.parseFloat(inputGST.SGST) > (Number.parseFloat(outputGST.SGST))) {
          returnOBJ.assets.SGST = (Number.parseFloat(inputGST.SGST) - (Number.parseFloat(outputGST.SGST))).toFixed(2) 
        } else {
          returnOBJ.assets.SGST = 0;
        } 

        if(Number.parseFloat(inputGST.SGST) < (Number.parseFloat(outputGST.SGST) )) {
          returnOBJ.liabilities.SGST = ((Number.parseFloat(outputGST.SGST)) - Number.parseFloat(inputGST.SGST)).toFixed(2)
        } else {
          returnOBJ.liabilities.SGST = 0;
        }
        return returnOBJ;

      },
      accountByBrand () {
        const accounts = this.accounts.filter(account => account.brand === this.selectedBrand);
        if(this.selectedFirm) {
          return accounts.filter(account => account.firm === this.selectedFirm)  
        }
        return accounts
      },
      // creditorByBrand() {
      //   if(this.creditors) {
      //     return this.creditors.filter(creditor => creditor['brand'] === this.selectedBrand)
      //   }
      //   return [];
      // },
      // customerByBrand() {
      //   if(this.customers) {
      //     return this.customers.filter(customer => customer['brand'] === this.selectedBrand)
      //   }
      //   return [];
      // },
      // list creditor by Id for diff for invoice
      creditorsById() {
        return this.creditorByBrand.map(item => item['.key'])
      },
      // list customer by Id for diff for invoice 
      customersById() {
        return this.customerByBrand.map(item => item['.key'])
      },
      // current brands firm list
      firmsByBrand () {
        // return selected brand firms
        return this.firms
          .filter((item) => item['brand'] === this.selectedBrand)
          .map(item => ({ text: item['name'], value: item['.key'], item }))
      },
      // all invoice for brand and firms
      invoiceByBrandAndFirm () {
        if(!this.invoices) { return [] };
        let filter = this.invoices.filter((item) => item['brand'] === this.selectedBrand);
        if(this.selectedFirm) {
          filter = filter.filter(item => item.firm === this.selectedFirm);
        }
        if(this.filterInvoiceFrom) {
          const from = new Date(this.filterInvoiceFrom).setHours(0,0,0,0);
          filter = filter.filter(item => item.date >= from)
        }
        if(this.filterInvoiceTo) {
          const to = new Date(this.filterInvoiceTo).setHours(23,29,59,999);
          filter = filter.filter(item => item.date <= to)
        }
        return filter;
      },
      // all invoice which are credited
      creditedInvoice() { return this.invoiceByBrandAndFirm.filter(invoice => invoice.isCredited) },
      // all invoice which are debited
      debitedInvoice() { return this.invoiceByBrandAndFirm.filter(invoice => !invoice.isCredited) },
      // expense list type by brand
      expenseByBrand() {
        if(!this.expenses) { return [] };
        // return expense with underhead 
        return this.expenses.filter((item) => item['brand'] === this.selectedBrand).map(item => item['.key']);
      },
      liabilityByBrand() {
        if(!this.liabilities) { return [] };
        // return expense with underhead 
        return this.liabilities.filter((item) => item['brand'] === this.selectedBrand).map(item => item['.key']);
      },
      // expense for which expense type is for brands
      invoiceByExpense() {
        return this.invoiceByBrandAndFirm.filter(invoice => {
          if(invoice.expenseType) {
            return this.expenseByBrand.includes(invoice.expenseType)
          }
          return false
        })
      },
      invoiceByLiability() {
        return this.invoiceByBrandAndFirm.filter(invoice => {
          if(invoice.liabilityType) {
            return this.liabilityByBrand.includes(invoice.liabilityType)
          }
          return false
        })
      },
      // total amount for expense by current brand
      invoiceByExpenseTotal() {
        return this.invoiceByExpense.reduce((total, item) => total + item.totalAmount, 0);
      },
      // total amount for liability by current brand
      invoiceByLiabilityTotal() {
        return this.invoiceByLiability.reduce((total, item) => total + item.totalAmount, 0);
      }, 
      // total Profit income from invoice by brand and firms
      invoiceTotalIncome() {
        return this.invoiceByBrandAndFirm.reduce((total, item) => {
          // calculate total Income for expense
          return total + Number.parseFloat(item['profit'] || 0)
        }, 0)
      },
      // for liabilities
      //  closing balance from net propA/C by firms
      propCapitalAC() {
        if(!this.selectedFirm) {
          return 0;
        }
        return this.selectedFirmDetail.openingBalance
      },
      // all invoice for brand with status "open"
      openInvoices() {
        return this.invoiceByBrandAndFirm.filter(item => item.status === 'open')
      },
      // all invoice by creditors
      openInvoiceByCreditor() {
        const invoice = []
        for(let i = 0; i !== this.openInvoices.length; i++){
          // diff invoice by customeId to creditor
          if(this.creditorsById.includes(this.openInvoices[i].customerId)) {
            invoice.push(this.openInvoices[i])
          }
        }
        return invoice;
      },
      // all invoice by customer (debtors)
      openInvoiceByCustomer() {
        const invoice = []
        for(let i = 0; i !== this.openInvoices.length; i++){
          // diff invoice by customeId to customer
          if(this.customersById.includes(this.openInvoices[i].customerId)) {
            invoice.push(this.openInvoices[i])
          }
        }
        return invoice;
      },
      // creditor invoice where item type is gold/silver
      openInvoiceByCreditorSundry() {
        return this.openInvoiceByCreditor.filter(invoice => {
          if(invoice.items && invoice.items[0]) {
            return invoice.items[0].type === 'Gold' || invoice.items[0].type === 'Silver'
          }
          return false
        })
      },
      // creditor invoice where item type is "without item"
      openInvoiceByCreditorUnsecured() {
        return this.openInvoiceByCreditor.filter(invoice => {
          if(invoice.items && invoice.items[0]) {
            return invoice.items[0].type === "Without item"
          }
          return false
        })
      },
      
      // creditor invoice where item type is gold/silver
      openInvoiceByCustomerSundry() {
        return this.openInvoiceByCustomer.filter(invoice => {
          if(invoice.items && invoice.items[0]) {
            return invoice.items[0].type === 'Gold' || invoice.items[0].type === 'Silver'
          }
          return false
        })
      },
      // creditor invoice where item type is "without item"
      openInvoiceByCustomerLoanNAdvances() {
        return this.openInvoiceByCustomer.filter(invoice => {
          if(invoice.items && invoice.items[0]) {
            return invoice.items[0].type === "Without item"
          }
          return false
        })
      },
      // Sundry Creditor total: Transaction with item taken by Creditor
      sundryCreditors() {
        return this.openInvoiceByCreditorSundry.reduce((total, item) => total + item.totalAmount, 0)
      },
      sundryCreditorsList() {
        const creditor = {}
        let calculated = []
        try {
          this.openInvoiceByCreditorSundry.forEach(invoice => {
            if(creditor[invoice.customerId]) {
              creditor[invoice.customerId].push(invoice)
            } else {
              creditor[invoice.customerId] = [invoice]
            }
          })
          Object.keys(creditor).forEach(customer => {
            const list = creditor[customer] || []
            calculated.push({
              type: 'creditor',
              invoices: creditor[customer],
              id: customer,
              amount: list.reduce((total, item) => total + item.totalAmount, 0),
            })
          })
        } catch (e) {
          console.info(e)
          return calculated
        }
        return calculated
      },
      // Creditors Unsecured Loans Total: landing money without item by Creditor
      unsecuredLoans() {
        return this.openInvoiceByCreditorUnsecured.reduce((total, item) => total + item.totalAmount, 0);
      },
      unsecuredLoansList() {
        const customers = {}
        let customerList = []
        try {
          this.openInvoiceByCreditorUnsecured.forEach(invoice => {
            if(customers[invoice.customerId]) {
              customers[invoice.customerId].push(invoice)
            } else {
              customers[invoice.customerId] = [invoice]
            }
          })
          Object.keys(customers).forEach(items => {
            const list = customers[items] || []
            customerList.push({
              type: 'creditor',
              invoices: customers[items],
              id: items,
              amount: list.reduce((total, item) => total + item.totalAmount, 0),
            })
          })
        } catch(e) {
          console.info(e)
        }
        return customerList;
      },
      // Debtors Total: Transaction with item taken by Customer(debtors)
      sundryDebtors() {
        return this.openInvoiceByCustomerSundry.reduce((total, item) => total + item.totalAmount, 0)
      },
      sundryDebtorsList() {
        const customers = {}
        let customerList = []
        try {
          this.openInvoiceByCustomerSundry.forEach(invoice => {
            if(customers[invoice.customerId]) {
              customers[invoice.customerId].push(invoice)
            } else {
              customers[invoice.customerId] = [invoice]
            }
          })
          Object.keys(customers).forEach(items => {
            const list = customers[items] || []
            customerList.push({
              type: 'customer',
              invoices: customers[items],
              id: items,
              amount: list.reduce((total, item) => total + item.totalAmount, 0),
            })
          })
        } catch(e) {
          console.info(e)
        }
        return customerList;
      },
      // landing money without by Customer (debtors)
      loansAndAdvances() {
        return this.openInvoiceByCustomerLoanNAdvances.reduce((total, item) => total + item.totalAmount, 0);
      },
      loansAndAdvancesList() {
        const customers = {}
        let customerList = []
        try {
          this.openInvoiceByCustomerLoanNAdvances.forEach(invoice => {
            if(customers[invoice.customerId]) {
              customers[invoice.customerId].push(invoice)
            } else {
              customers[invoice.customerId] = [invoice]
            }
          })
          Object.keys(customers).forEach(items => {
            const list = customers[items] || []
            customerList.push({
              type: 'customer',
              invoices: customers[items],
              id: items,
              amount: list.reduce((total, item) => total + item.totalAmount, 0),
            })
          })
        } catch(e) {
          console.info(e)
        }
        return customerList;
      },
      // bank with list
      securedLoansBankList() {
        return this.accountByBrand.filter(bank => bank.accountType === 'Loan A/C' || bank.accountType === 'Overdraft A/C')
      },
      // Total of amount of secured loans bank
      securedLoansBankListTotal() {
        return this.securedLoansBankList.reduce((total, bank) => total + bank.amount, 0);
      },
      // secured account bank list
      savingsCurrentBankList() {
        return this.accountByBrand.filter(bank => bank.accountType === 'Saving A/C' || bank.accountType === 'Current A/C')
      },
      // total of amount of saving/current bank account
      savingsCurrentBankListTotal() {
        return this.savingsCurrentBankList.reduce((total, bank) => total + bank.amount, 0);
      },
      // cash in hand: firms available cash
      cashInHand() {
        if(this.selectedFirm) {
          const firm = this.firmsByBrand.find(firm => firm.value === this.selectedFirm);
          return firm.item.amount
        }
        return this.firmsByBrand.reduce((balance, firm) => {
          return balance = balance + firm.item.amount
        }, 0)
      },
      totalAssetAmount() {
        return this.getAssetAccount.reduce((total, item) => {
          return (item.details.totalAmount + item.details.openingBalance) - ((item.details.totalAmount + item.details.openingBalance) * ((this.isDepriciation  ? item.details.depriciation : 0) /100) || 0)  + total
        }, 0)
      },
      totalInvestmentAmount() {
        return this.getInvestmentAccount.reduce((total, item) => {
          return item.details.totalAmount + item.details.openingBalance  + total
        }, 0)
      },
      assetByBrand() {
        if(!this.assets) { return [] };
        // return asset with underhead 
        return this.assets.filter((item) => item['brand'] === this.selectedBrand && item.type != 'investments');
      },
      assetAsInvestmentByBrand() {
        if(!this.assets) { return [] };
        // return asset with underhead 
        return this.assets.filter((item) => item['brand'] === this.selectedBrand && item.type === 'investments');
      },
      invoiceByBrand() {
        if(!this.invoices) { return [] };
        let filter = this.invoices.filter((item) => item['brand'] === this.selectedBrand);
        if(this.selectedFirm) {
          filter = filter.filter(item => item.firm === this.selectedFirm);
        }
        if(this.filterInvoiceFrom) {
          const from = new Date(this.filterInvoiceFrom).setHours(0,0,0,0);
          filter = filter.filter(item => item.date >= from)
        }
        if(this.filterInvoiceTo) {
          const to = new Date(this.filterInvoiceTo).setHours(23,29,59,999);
          filter = filter.filter(item => item.date <= to)
        }
        return filter;
      },
      getAssetAccount() {
        const mainGroup = [] // { details: {} && invoices: []}
        try {
          this.assetByBrand.forEach(details => {
            const invoices = this.invoiceByBrand.filter(invoice => {
              if(this.selectedFirm) {
                // return invoice of selected firmId
                return invoice.assetType === details['.key'] && invoice.firm === this.selectedFirm
              }
              // return all matched key invoices
              return invoice.assetType === details['.key'];
            })
            details.totalAmount = invoices.reduce((total, item) => {
              return total + item.totalAmount  
            }, 0)
            details.openingBalance = invoices.reduce((total, item) => {
              return total + item.openingBalance 
            }, 0)
            if(details.totalAmount) {
              mainGroup.push({
                details,
                invoices
              }) 
            }
            else if (details.openingBalance) {
              mainGroup.push({
                details,
                invoices
              }) 
            }
          })
          return mainGroup
        } catch(e) {
          console.info(e)
          return []
        }
      },
      getInvestmentAccount() {
        const mainGroup = [] // { details: {} && invoices: []}
        try {
          this.assetAsInvestmentByBrand.forEach(details => {
            const invoices = this.invoiceByBrand.filter(invoice => {
              if(this.selectedFirm) {
                // return invoice of selected firmId
                return invoice.assetType === details['.key'] && invoice.firm === this.selectedFirm
              }
              // return all matched key invoices
              return invoice.assetType === details['.key'];
            })
            details.totalAmount = invoices.reduce((total, item) => {
              return total + item.totalAmount  
            }, 0)
            details.openingBalance = invoices.reduce((total, item) => {
              return total + item.openingBalance 
            }, 0)
            if(details.totalAmount) {
              mainGroup.push({
                details,
                invoices
              }) 
            }
            else if (details.openingBalance) {
              mainGroup.push({
                details,
                invoices
              }) 
            }
          })
          return mainGroup
        } catch(e) {
          console.info(e)
          return []
        }
      },
    },
    data: () => ({ 
      isDepriciation : true,
      selectedFirm: null,
      filterInvoiceFrom: null,
      filterInvoiceTo: null,
      fromdatepicker: false,
      todatepicker: false,
      searchInput: null,
      totalSundryCreditors : 0,
      totalSundryDebitors : 0,
      totalLoan : 0,
      totalLoanAndAdvances : 0,
      buyerList : [],
      sellerList : [],
      expensesWPro : [],
      expenseTotal : 0,
     }),
    methods: {
      getName(key, property, name) {
        const dd = this[property].find(item => item['.key'] === key);
        if(dd) {
          return dd[name] || key
        }
        return key
      },
    getData(){
      this.usersByBrand();
      this.expenseWithProvision();
      this.liabilityWithProvision();
    },
    expenseWithProvision(){
        this.expenseTotal = 0;
        let expenses = this.expenses.filter(expense => expense.brand === this.selectedBrand);
        expenses = expenses.filter(expense => !!expense['.key']);
        expenses.map((ex,index)=>{
          let openingBalance = 0;
          let totalAmount = 0;
          let paymentTypeStatus = 'confirm';
          let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["expenseType"] === ex['.key'])
          console.log(invoices)
          invoices.map((inv)=>{
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            totalAmount += Number.parseFloat(inv.totalAmount)
            if(paymentTypeStatus == 'confirm') {
              paymentTypeStatus = inv.paymentTypeStatus;
            }
          });
          expenses[index].paymentTypeStatus = paymentTypeStatus;
          expenses[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
          expenses[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
          if(expenses[index].paymentTypeStatus == 'yet to confirm') {
            console.log(totalAmount)
            this.expenseTotal = isNaN(totalAmount) ? this.expenseTotal : Number.parseFloat(this.expenseTotal) + Number.parseFloat(totalAmount);
          }
        })
        this.expenseTotal = Number.parseFloat(this.expenseTotal);
        this.expensesWPro = expenses;
      },
      // Liability With Provision
      liabilityWithProvision(){
        this.liabilityTotal = 0;
        let liabilities = this.liabilities.filter(liability => liability.brand === this.selectedBrand);
        liabilities = liabilities.filter(liability => !!liability['.key']);
        liabilities.map((ex,index)=>{
          let openingBalance = 0;
          let totalAmount = 0;
          let paymentTypeStatus = 'confirm';
          let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["liabilityType"] === ex['.key'])
          console.log(invoices)
          invoices.map((inv)=>{
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            totalAmount += Number.parseFloat(inv.totalAmount)
            if(paymentTypeStatus == 'confirm') {
              paymentTypeStatus = inv.paymentTypeStatus;
            }
          });
          liabilities[index].paymentTypeStatus = paymentTypeStatus;
          liabilities[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
          liabilities[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
          if(liabilities[index].paymentTypeStatus == 'yet to confirm') {
            console.log(totalAmount)
            this.liabilityTotal = isNaN(totalAmount) ? this.liabilityTotal : Number.parseFloat(this.liabilityTotal) + Number.parseFloat(totalAmount);
          }
        })
        this.liabilityTotal = Number.parseFloat(this.liabilityTotal);
        this.liabilitiesWPro = liabilities;
      },
      usersByBrand() {
        if(this.sellers) {
          this.totalLoan = 0;
          this.totalLoanAndAdvances = 0;
          this.totalSundryCreditors = 0;
          this.sellerList = this.sellers.filter(customer => customer['brand'] === this.selectedBrand);
          this.sellerList.map((seller,index)=>{
              this.sellerList[index]['totalDiscount'] = 0;
              this.sellerList[index]['totalDueAmount'] = 0;
              this.sellerList[index]['totalAdvance'] = 0;
              this.sellerList[index]['totalSecurity'] = 0;
              this.sellerList[index]['totalOpeningBal'] = 0;
              this.sellerList[index]['totalLoanGiven'] = 0;
              this.sellerList[index]['totalLoanTaken'] = 0;
              let invoices  = this.invoices.filter(
                  item =>
                    item["brand"] === this.selectedBrand &&
                    item["buyerId"] === seller['.key'] &&
                    (item["status"] === "due" || item["status"] === "partial") &&
                    (this.selectedFirm
                      ? item["firm"] === this.selectedFirm
                      : true)
                );
              invoices.map((inv) => {
                this.sellerList[index]['totalDueAmount'] += Number.parseFloat(inv.remainingAmount);
                this.sellerList[index]['totalDiscount'] += Number.parseFloat(inv.discountAmount);
              });

              let advanceInv = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "Advance" &&
                  !!item["isUserCreated"] && 
                  (parseInt(item["remainingAmount"]) > 0) && 
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm
                    : true)
                );
              advanceInv.map((inv)  => {
                this.sellerList[index]['totalAdvance'] = inv.remainingAmount;
              });

              let securityInv = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "Security" &&
                  !!item["isUserCreated"] && 
                  (parseInt(item["remainingAmount"]) > 0) && 
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm
                    : true)
                );
              securityInv.map((inv)  => {
                this.sellerList[index]['totalSecurity'] = inv.remainingAmount;
              });

              let openingInv = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "Opening Balance" &&
                  !!item["isUserCreated"] && 
                  (parseInt(item["remainingAmount"]) > 0) && 
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm
                    : true)
                );
              openingInv.map((inv)  => {
                this.sellerList[index]['totalOpeningBal'] = inv.remainingAmount;
              });

              let loanInv = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "Loan Given" &&
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm
                    : true)
                );
              loanInv.map((inv)  => {
                this.sellerList[index]['totalLoanGiven'] += Number.parseFloat(inv.amount);
              });

              let loanInvTkn = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "Loan Taken" &&
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm
                    : true)
                );
              loanInvTkn.map((inv)  => {
                this.sellerList[index]['totalLoanTaken'] += Number.parseFloat(inv.amount);
              });

              this.totalLoan += Number.parseFloat(this.sellerList[index]['totalLoanGiven']);
              this.totalLoanAndAdvances += Number.parseFloat(this.sellerList[index]['totalLoanTaken']);
             this.sellerList[index]['totalRemainingAmount'] = (Number.parseFloat(this.sellerList[index]['totalOpeningBal']) + Number.parseFloat(this.sellerList[index]['totalDueAmount'])) - (Number.parseFloat(this.sellerList[index]['totalAdvance']) + Number.parseFloat(this.sellerList[index]['totalSecurity']) + Number.parseFloat(this.sellerList[index]['totalDiscount']));
             this.totalSundryCreditors += Number.parseFloat(this.sellerList[index]['totalRemainingAmount']);
          });
        }

        if(this.buyers) {
          this.totalSundryDebitors = 0;
          this.buyerList = this.buyers.filter(customer => customer['brand'] === this.selectedBrand);
          this.buyerList.map((seller,index)=>{
              this.buyerList[index]['totalDiscount'] = 0;
              this.buyerList[index]['totalDueAmount'] = 0;
              this.buyerList[index]['totalAdvance'] = 0;
              this.buyerList[index]['totalSecurity'] = 0;
              this.buyerList[index]['totalOpeningBal'] = 0;
              this.buyerList[index]['totalLoanTaken'] = 0;
              this.buyerList[index]['totalLoanGiven'] = 0;
              this.buyerList[index]['totalRemainingAmount'] = 0;
              let invoices  = this.invoices.filter(
                  item =>
                    item["brand"] === this.selectedBrand &&
                    item["buyerId"] === seller['.key'] &&
                    (item["status"] === "due" || item["status"] === "partial") &&
                    (this.selectedFirm
                      ? item["firm"] === this.selectedFirm
                      : true)
                );
              invoices.map((inv) => {
                console.log(this.buyerList[index]['totalDueAmount'])
                this.buyerList[index]['totalDueAmount'] += inv.remainingAmount ? Number.parseFloat(inv.remainingAmount) : 0;
                this.buyerList[index]['totalDiscount'] += inv.discountAmount ? Number.parseFloat(inv.discountAmount) : 0;
              });

              let advanceInv = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "Advance" &&
                  !!item["isUserCreated"] && 
                  (parseInt(item["remainingAmount"]) > 0) && 
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm
                    : true)
                );
              advanceInv.map((inv)  => {
                this.buyerList[index]['totalAdvance'] = inv.remainingAmount;
              });

              let securityInv = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "Security" &&
                  !!item["isUserCreated"] && 
                  (parseInt(item["remainingAmount"]) > 0) && 
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm
                    : true)
                );
              securityInv.map((inv)  => {
                this.buyerList[index]['totalSecurity'] = inv.remainingAmount;
              });

              let openingInv = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "Opening Balance" &&
                  !!item["isUserCreated"] && 
                  (parseInt(item["remainingAmount"]) > 0) && 
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm
                    : true)
                );
              openingInv.map((inv)  => {
                this.buyerList[index]['totalOpeningBal'] = inv.remainingAmount;
              });

              let loanInv = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "Loan Taken" &&
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm
                    : true)
                );
              loanInv.map((inv)  => {
                this.buyerList[index]['totalLoanTaken'] += Number.parseFloat(inv.amount);
              });

              let loanInvGV = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "Loan Given" &&
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm
                    : true)
                );
              loanInvGV.map((inv)  => {
                this.buyerList[index]['totalLoanGiven'] += Number.parseFloat(inv.amount);
              });

              this.totalLoanAndAdvances += Number.parseFloat(this.buyerList[index]['totalLoanTaken']);
              this.totalLoan += Number.parseFloat(this.buyerList[index]['totalLoanGiven']);
              this.buyerList[index]['totalRemainingAmount'] = (Number.parseFloat(this.buyerList[index]['totalOpeningBal']) + Number.parseFloat(this.buyerList[index]['totalDueAmount'])) - (Number.parseFloat(this.buyerList[index]['totalAdvance']) + Number.parseFloat(this.buyerList[index]['totalSecurity']) + Number.parseFloat(this.buyerList[index]['totalDiscount']));
              this.totalSundryDebitors += Number.parseFloat(this.buyerList[index]['totalRemainingAmount']);
          });
        }
      },
    }
  }
</script>
<style>
.v-data-iterator.balance .v-expansion-panel__header__icon {
  display: none;
}
.v-data-iterator.balance .v-expansion-panel__header {
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Informations/Balancesheet/index.vue